/**
 *  Copyright (c) 2026 TechDivision GmbH
 *  All rights reserved
 *
 *  This product includes proprietary software developed at TechDivision GmbH, Germany
 *  For more information see https://www.techdivision.com/
 *
 *  To obtain a valid license for using this software please contact us at
 *  license@techdivision.com
 *
 */

/* product-cards.js
   Product card section - per-card read-more toggle for the description, which
   is clamped to nine lines via CSS. The toggle swaps its label between "read
   more" and "read less"; the editor's own call to action sits in the same row
   and stays clickable whether the card is open or closed. */
function initProductCardToggles() {
  var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-product-toggle]'));

  toggles.forEach(function (btn) {
    // the toggle names its description through aria-controls, so the two do not
    // have to be siblings in the DOM
    var desc = document.getElementById(btn.getAttribute('aria-controls'));
    if (!desc || !desc.hasAttribute('data-product-desc')) return;

    var label = btn.querySelector('[data-product-toggle-label]');

    // reveal the toggle only when the clamped text overflows its nine lines
    if (desc.scrollHeight - desc.clientHeight > 1) {
      btn.classList.remove('hidden');
    }

    btn.addEventListener('click', function (event) {
      // the card carries a stretched overlay link that would otherwise navigate
      // away instead of expanding
      event.preventDefault();
      event.stopPropagation();

      var expanded = desc.classList.toggle('line-clamp-[9]') === false;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = btn.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
      }
    });
  });
}

initProductCardToggles();
